import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-custom-text-filter',
  templateUrl: './custom-text-filter.component.html',
  styleUrls: ['./custom-text-filter.component.scss'],
  standalone: true,
  imports: [TableModule, FormsModule, ReactiveFormsModule, InputTextModule]
})
export class CustomTextFilterComponent {
  @Input() field!: string;
  @Input() control!: FormControl;
  @Output() onChangeTextFilter = new EventEmitter<{ propertyName: string, valueFilter: any }>();

  filterInput(event: Event) {
    const inputElement = event.target as HTMLInputElement;

    // Si el valor es vacío, manda null para evitar errores en PrimeNG
    const value = inputElement.value.trim() === '' ? null : inputElement.value;

    this.onChangeTextFilter.emit({ propertyName: this.field, valueFilter: value });
  }
}
